import SeatUIModel from './seat';

class SeatmapRowUIModel {
  /**
   * constructor
   * @param {Object} options
   */
  constructor({
    code = '',
    isPremierLight = false,
    seats = [],
    sectionClass = '',
    sectionCode = '',
  }) {
    this.code = code;
    this.seats = [];
    seats._collection.forEach((seat, index) => {
      this.seats.push(new SeatUIModel(seat));
      if (sectionClass === 'FIRST_CLASS' && isPremierLight && (index === 0 || index === 2)) {
        seat.status = 'BLOCKED';
        this.seats.push(new SeatUIModel(seat));
      }
    });
    this.sectionCode = sectionCode;
  }
}

export default SeatmapRowUIModel;
